import dayjs from 'dayjs';
import { chain } from 'lodash';
import { IAssembly, IMappedLocationGroupDaypart } from 'src/interfaces';

export const formatSchedules = (
  schedules: IMappedLocationGroupDaypart[],
  assemblies: IAssembly[],
  locationCode: string,
) => {
  const filteredSchedules = chain(schedules)
    .filter(
      (assembly) =>
        !assembly.locationCode || assembly.locationCode === locationCode,
    )
    .value();
  const formattedSchedules = filteredSchedules.map((schedule) => {
    const assemblyComponents = assemblies.find(
      (assembly) => assembly.id === schedule.assemblyData.id,
    );

    return {
      ...schedule,
      isEditable:
        !!assemblyComponents?.assemblyComponents?.some(
          (assemblyComponent) => assemblyComponent.allow_overrides,
        ) && !isEndDateExpired(schedule.endDate),
    };
  });

  return formattedSchedules;
};

export const isEndDateExpired = (endDate: string | null) => {
  const isExpired = dayjs().isAfter(dayjs(endDate));

  return isExpired;
};

export const isFutureStartDate = (startDate: string | null) => {
  const isFuture = dayjs().isBefore(dayjs(startDate));

  return isFuture;
};
